'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findNumbers;

var _findPhoneNumbers = require('./findPhoneNumbers');

var _PhoneNumberMatcher = require('./PhoneNumberMatcher');

var _PhoneNumberMatcher2 = _interopRequireDefault(_PhoneNumberMatcher);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function findNumbers(arg_1, arg_2, arg_3, arg_4) {
  var _sort_out_arguments = (0, _findPhoneNumbers.sort_out_arguments)(arg_1, arg_2, arg_3, arg_4),
      text = _sort_out_arguments.text,
      options = _sort_out_arguments.options,
      metadata = _sort_out_arguments.metadata;

  var matcher = new _PhoneNumberMatcher2.default(text, options, metadata);
  var results = [];

  while (matcher.hasNext()) {
    results.push(matcher.next());
  }

  return results;
}